// extracted by mini-css-extract-plugin
export var aspectRatio = "aspect_ratio-module--aspectRatio--OMio5";
export var content = "aspect_ratio-module--content--pdrln";